import { BASE_URL } from '../api';
import { getUserByUsername, updateUser } from './users';

/**
 * Hash de contraseña (puede estar aquí si es específico de auth)
 */
export async function hashPassword(password) {
  if (!password) {
    return "";
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(password);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return btoa(String.fromCharCode(...hashArray));
}

export async function login(username, password) {
   const trimmedPassword = typeof password === "string" ? password.trim() : "";
  const isBlankPassword = trimmedPassword.length === 0;
  const pass_hash = isBlankPassword ? "" : await hashPassword(trimmedPassword);
  const body = { username, pass_hash, app: "Web" };

  try {
    const res = await fetch(`${BASE_URL}/token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      return { success: false, needsPasswordReset: false, data: null };
    }

    const data = await res.json();

    if (data?.Token) {
      localStorage.setItem("token", data.Token);
      const isVerified = data?.IsVerified;
       const userIsVerified = isVerified !== false;
      const needsPasswordReset = isBlankPassword || isVerified === false;
      return {
        success: userIsVerified && !needsPasswordReset,
        needsPasswordReset,
        data,
      };
    }

    return { success: false, needsPasswordReset: false, data };
  } catch (error) {
    console.error("Error iniciando sesión:", error);
    return { success: false, needsPasswordReset: false, error };
  }
}

export async function logout() {
  try {
    await fetch(`${BASE_URL}/token`, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    });
  } catch (err) {
    console.warn("Error al cerrar sesión en backend:", err);
  } finally {
    localStorage.removeItem("token");
  }
}

export async function getInfo() {
  const token = localStorage.getItem("token");
  const res = await fetch(`${BASE_URL}/info`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return res.text();
}

export function isAuthenticated() {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Date.now() / 1000;
    return payload.exp && payload.exp > now;
  } catch {
    return false;
  }
}

export function getCurrentUsername() {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.UserName || null;
  } catch {
    return null;
  }
}

export const getCurrentUser = () => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload;
  } catch (error) {
    console.error("Error parsing user from token:", error);
    return null;
  }
};

export const hasRole = (role) => {
  const user = getCurrentUser();
  if (!user || !user.ROLES) return false;
  
  // ROLES può essere stringa o array
  const roles = Array.isArray(user.ROLES) ? user.ROLES : [user.ROLES];
  return roles.includes(role);
};

export const canModifyOrderStates = () => {
  // Controlla se l'utente ha uno dei ruoli che permettono modifica stati
  return hasRole('BiConnectPro') || hasRole('dbAdmin');
};

export async function completeInitialPasswordSetup(username, newPassword) {
  if (!username) {
    throw new Error("El nombre de usuario es obligatorio.");
  }

  if (!newPassword) {
    throw new Error("La nueva contraseña es obligatoria.");
  }

  const userData = await getUserByUsername(username);

  if (!userData || !userData.USER || !userData.COD_ID) {
    throw new Error("No se pudo obtener la información del usuario.");
  }

  const NEW_PASS_HASH = await hashPassword(newPassword);

  const payload = {
    COD_ID: userData.COD_ID,
    USER: userData.USER,
    NEW_PASS_HASH,
    CURR_PASS_HASH: "",
  };

  const response = await updateUser(payload);

  if (!response || response.status !== "OK") {
    throw new Error("No se pudo establecer la contraseña. Inténtalo nuevamente.");
  }

  return response;
}